import { ModuleCommandEnum } from "@/types/enums/module-command.enum";

export const PATH_TO_IMAGES = "/posts/";
export const EXTENSION = ".svg";

export const getModuleImageForCommand = (command: ModuleCommandEnum) => {
  switch (command) {
    case ModuleCommandEnum.CLOSE:
      return `${PATH_TO_IMAGES}up${EXTENSION}`;
    case ModuleCommandEnum.OPEN:
      return `${PATH_TO_IMAGES}unfolded${EXTENSION}`;
    case ModuleCommandEnum.UP:
      return `${PATH_TO_IMAGES}up${EXTENSION}`;
    case ModuleCommandEnum.DOWN:
      return `${PATH_TO_IMAGES}folded${EXTENSION}`;
  }
};
